// Feedback questionnaires now live on each edition's page (its "استمارة
// التقييم" and "الإجابات" tabs), reached from the trainings area's editions
// tab. This route stays only so bookmarks and old links still land somewhere.

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/questionnaires")({
	beforeLoad: () => {
		throw redirect({ to: "/admin/trainings" });
	},
});
